module.exports = {
  "en_US": [
    {
      "name": "Accounting",
      "order": 1,
      "short_code": "p1"
    },
    {
      "name": "Airport",
      "order": 2,
      "short_code": "p2"
    },
    {
      "name": "Amusement Park",
      "order": 3,
      "short_code": "p3"
    },
    {
      "name": "Aquarium",
      "order": 4,
      "short_code": "p4"
    },
    {
      "name": "Art Gallery",
      "order": 5,
      "short_code": "p5"
    },
    {
      "name": "Bakery",
      "order": 7,
      "short_code": "p7"
    },
    {
      "name": "Bank",
      "order": 8,
      "short_code": "p8"
    },
    {
      "name": "Bar",
      "order": 9,
      "short_code": "p9"
    },
    {
      "name": "Beauty Salon",
      "order": 10,
      "short_code": "p10"
    },
    {
      "name": "Bicycle Store",
      "order": 11,
      "short_code": "p11"
    },
    {
      "name": "Book Store",
      "order": 12,
      "short_code": "p12"
    },
    {
      "name": "Bowling Alley",
      "order": 13,
      "short_code": "p13"
    },
    {
      "name": "Bus Station",
      "order": 14,
      "short_code": "p14"
    },
    {
      "name": "Cafe",
      "order": 15,
      "short_code": "p15"
    },
    {
      "name": "Campground",
      "order": 16,
      "short_code": "p16"
    },
    {
      "name": "Car Dealer",
      "order": 17,
      "short_code": "p17"
    },
    {
      "name": "Car Repair",
      "order": 19,
      "short_code": "p19"
    },
    {
      "name": "Car Wash",
      "order": 20,
      "short_code": "p20"
    },
    {
      "name": "Casino",
      "order": 21,
      "short_code": "p21"
    },
    {
      "name": "Church",
      "order": 23,
      "short_code": "p23"
    },
    {
      "name": "Clinic",
      "order": 24,
      "short_code": "p24"
    },
    {
      "name": "Clothing Store",
      "order": 26,
      "short_code": "p26"
    },
    {
      "name": "Convenience Store",
      "order": 27,
      "short_code": "p27"
    },
    {
      "name": "Co-working Space",
      "order": 29,
      "short_code": "p29"
    },
    {
      "name": "Dentist",
      "order": 30,
      "short_code": "p30"
    },
    {
      "name": "Department Store",
      "order": 31,
      "short_code": "p31"
    },
    {
      "name": "Decoration",
      "order": 32,
      "short_code": "p32"
    },
    {
      "name": "Education Center",
      "order": 33,
      "short_code": "p33"
    },
    {
      "name": "Electronics Store",
      "order": 35,
      "short_code": "p35"
    },
    {
      "name": "Fire Station",
      "order": 37,
      "short_code": "p37"
    },
    {
      "name": "Florist",
      "order": 38,
      "short_code": "p38"
    },
    {
      "name": "Food Store",
      "order": 39,
      "short_code": "p39"
    },
    {
      "name": "Furniture Store",
      "order": 41,
      "short_code": "p41"
    },
    {
      "name": "Gas Station",
      "order": 42,
      "short_code": "p42"
    },
    {
      "name": "Gym",
      "order": 43,
      "short_code": "p43"
    },
    {
      "name": "Hair Salon",
      "order": 44,
      "short_code": "p44"
    },
    {
      "name": "Hardware Store",
      "order": 45,
      "short_code": "p45"
    },
    {
      "name": "Home Goods Store",
      "order": 47,
      "short_code": "p47"
    },
    {
      "name": "Hospital",
      "order": 48,
      "short_code": "p48"
    },
    {
      "name": "Insurance Agency",
      "order": 49,
      "short_code": "p49"
    },
    {
      "name": "Jewelry Store",
      "order": 50,
      "short_code": "p50"
    },
    {
      "name": "Laundry",
      "order": 51,
      "short_code": "p51"
    },
    {
      "name": "Law Firm",
      "order": 52,
      "short_code": "p52"
    },
    {
      "name": "Library",
      "order": 53,
      "short_code": "p53"
    },
    {
      "name": "Light Rail Station",
      "order": 54,
      "short_code": "p54"
    },
    {
      "name": "Liquor Store",
      "order": 55,
      "short_code": "p55"
    },
    {
      "name": "Lodging",
      "order": 58,
      "short_code": "p58"
    },
    {
      "name": "Movie Theater",
      "order": 63,
      "short_code": "p63"
    },
    {
      "name": "Moving Company",
      "order": 64,
      "short_code": "p64"
    },
    {
      "name": "Museum",
      "order": 65,
      "short_code": "p65"
    },
    {
      "name": "Night Club",
      "order": 66,
      "short_code": "p66"
    },
    {
      "name": "Park",
      "order": 68,
      "short_code": "p68"
    },
    {
      "name": "Parking",
      "order": 69,
      "short_code": "p69"
    },
    {
      "name": "Pet Store",
      "order": 70,
      "short_code": "p70"
    },
    {
      "name": "Pharmacy",
      "order": 71,
      "short_code": "p71"
    },
    {
      "name": "Physiotherapy",
      "order": 72,
      "short_code": "p72"
    },
    {
      "name": "Primary School",
      "order": 76,
      "short_code": "p76"
    },
    {
      "name": "Real Estate Agency",
      "order": 77,
      "short_code": "p77"
    },
    {
      "name": "Restaurant",
      "order": 78,
      "short_code": "p78"
    },
    {
      "name": "Rv Park",
      "order": 80,
      "short_code": "p80"
    },
    {
      "name": "School",
      "order": 81,
      "short_code": "p81"
    },
    {
      "name": "Secondary School",
      "order": 82,
      "short_code": "p82"
    },
    {
      "name": "Shoe Store",
      "order": 83,
      "short_code": "p83"
    },
    {
      "name": "Shopping Mall",
      "order": 84,
      "short_code": "p84"
    },
    {
      "name": "Spa",
      "order": 85,
      "short_code": "p85"
    },
    {
      "name": "Stadium",
      "order": 86,
      "short_code": "p86"
    },
    {
      "name": "Storage",
      "order": 87,
      "short_code": "p87"
    },
    {
      "name": "Store",
      "order": 88,
      "short_code": "p88"
    },
    {
      "name": "Subway Station",
      "order": 89,
      "short_code": "p89"
    },
    {
      "name": "Supermarket",
      "order": 90,
      "short_code": "p90"
    },
    {
      "name": "Tourist Attraction",
      "order": 93,
      "short_code": "p93"
    },
    {
      "name": "Train Station",
      "order": 94,
      "short_code": "p94"
    },
    {
      "name": "Travel Agency",
      "order": 96,
      "short_code": "p96"
    },
    {
      "name": "University",
      "order": 97,
      "short_code": "p97"
    },
    {
      "name": "Veterinary Care",
      "order": 98,
      "short_code": "p98"
    },
    {
      "name": "Zoo",
      "order": 99,
      "short_code": "p99"
    },
    {
      "name": "Other",
      "order": 100,
      "short_code": "por"
    }
  ],
  "zh_HK": [
    {
      "name": "會計",
      "order": 1,
      "short_code": "p1"
    },
    {
      "name": "飛機場",
      "order": 2,
      "short_code": "p2"
    },
    {
      "name": "遊樂園",
      "order": 3,
      "short_code": "p3"
    },
    {
      "name": "水族館",
      "order": 4,
      "short_code": "p4"
    },
    {
      "name": "藝術畫廊",
      "order": 5,
      "short_code": "p5"
    },
    {
      "name": "麵包店",
      "order": 7,
      "short_code": "p7"
    },
    {
      "name": "銀行",
      "order": 8,
      "short_code": "p8"
    },
    {
      "name": "酒吧",
      "order": 9,
      "short_code": "p9"
    },
    {
      "name": "美容院",
      "order": 10,
      "short_code": "p10"
    },
    {
      "name": "自行車店",
      "order": 11,
      "short_code": "p11"
    },
    {
      "name": "書店",
      "order": 12,
      "short_code": "p12"
    },
    {
      "name": "保齡球館",
      "order": 13,
      "short_code": "p13"
    },
    {
      "name": "公車站",
      "order": 14,
      "short_code": "p14"
    },
    {
      "name": "咖啡店",
      "order": 15,
      "short_code": "p15"
    },
    {
      "name": "營地",
      "order": 16,
      "short_code": "p16"
    },
    {
      "name": "汽車經銷商",
      "order": 17,
      "short_code": "p17"
    },
    {
      "name": "汽車修理",
      "order": 19,
      "short_code": "p19"
    },
    {
      "name": "洗車",
      "order": 20,
      "short_code": "p20"
    },
    {
      "name": "賭場",
      "order": 21,
      "short_code": "p21"
    },
    {
      "name": "教會",
      "order": 23,
      "short_code": "p23"
    },
    {
      "name": "診所",
      "order": 24,
      "short_code": "p24"
    },
    {
      "name": "服裝店",
      "order": 26,
      "short_code": "p26"
    },
    {
      "name": "便利店",
      "order": 27,
      "short_code": "p27"
    },
    {
      "name": "共享工作空間",
      "order": 29,
      "short_code": "p29"
    },
    {
      "name": "牙醫",
      "order": 30,
      "short_code": "p30"
    },
    {
      "name": "百貨商店",
      "order": 31,
      "short_code": "p31"
    },
    {
      "name": "裝修",
      "order": 32,
      "short_code": "p32"
    },
    {
      "name": "教育中心",
      "order": 33,
      "short_code": "p33"
    },
    {
      "name": "電子商店",
      "order": 35,
      "short_code": "p35"
    },
    {
      "name": "消防站",
      "order": 37,
      "short_code": "p37"
    },
    {
      "name": "花店",
      "order": 38,
      "short_code": "p38"
    },
    {
      "name": "食品店",
      "order": 39,
      "short_code": "p39"
    },
    {
      "name": "家具店",
      "order": 41,
      "short_code": "p41"
    },
    {
      "name": "加油站",
      "order": 42,
      "short_code": "p42"
    },
    {
      "name": "健身房",
      "order": 43,
      "short_code": "p43"
    },
    {
      "name": "髮廊",
      "order": 44,
      "short_code": "p44"
    },
    {
      "name": "五金店",
      "order": 45,
      "short_code": "p45"
    },
    {
      "name": "家居用品店",
      "order": 47,
      "short_code": "p47"
    },
    {
      "name": "醫院",
      "order": 48,
      "short_code": "p48"
    },
    {
      "name": "保險代理",
      "order": 49,
      "short_code": "p49"
    },
    {
      "name": "珠寶店",
      "order": 50,
      "short_code": "p50"
    },
    {
      "name": "洗衣店",
      "order": 51,
      "short_code": "p51"
    },
    {
      "name": "律師樓",
      "order": 52,
      "short_code": "p52"
    },
    {
      "name": "圖書館",
      "order": 53,
      "short_code": "p53"
    },
    {
      "name": "輕軌站",
      "order": 54,
      "short_code": "p54"
    },
    {
      "name": "酒品店",
      "order": 55,
      "short_code": "p55"
    },
    {
      "name": "住宿",
      "order": 58,
      "short_code": "p58"
    },
    {
      "name": "電影院",
      "order": 63,
      "short_code": "p63"
    },
    {
      "name": "搬家公司",
      "order": 64,
      "short_code": "p64"
    },
    {
      "name": "博物館",
      "order": 65,
      "short_code": "p65"
    },
    {
      "name": "夜店",
      "order": 66,
      "short_code": "p66"
    },
    {
      "name": "公園",
      "order": 68,
      "short_code": "p68"
    },
    {
      "name": "停車處",
      "order": 69,
      "short_code": "p69"
    },
    {
      "name": "寵物店",
      "order": 70,
      "short_code": "p70"
    },
    {
      "name": "藥店",
      "order": 71,
      "short_code": "p71"
    },
    {
      "name": "物理治療",
      "order": 72,
      "short_code": "p72"
    },
    {
      "name": "小學",
      "order": 76,
      "short_code": "p76"
    },
    {
      "name": "房地產中介",
      "order": 77,
      "short_code": "p77"
    },
    {
      "name": "餐廳",
      "order": 78,
      "short_code": "p78"
    },
    {
      "name": "房車公園",
      "order": 80,
      "short_code": "p80"
    },
    {
      "name": "學校",
      "order": 81,
      "short_code": "p81"
    },
    {
      "name": "中學",
      "order": 82,
      "short_code": "p82"
    },
    {
      "name": "鞋店",
      "order": 83,
      "short_code": "p83"
    },
    {
      "name": "購物中心",
      "order": 84,
      "short_code": "p84"
    },
    {
      "name": "溫泉",
      "order": 85,
      "short_code": "p85"
    },
    {
      "name": "體育場",
      "order": 86,
      "short_code": "p86"
    },
    {
      "name": "貯存",
      "order": 87,
      "short_code": "p87"
    },
    {
      "name": "店鋪",
      "order": 88,
      "short_code": "p88"
    },
    {
      "name": "地鐵站",
      "order": 89,
      "short_code": "p89"
    },
    {
      "name": "超級市場",
      "order": 90,
      "short_code": "p90"
    },
    {
      "name": "旅遊景點",
      "order": 93,
      "short_code": "p93"
    },
    {
      "name": "火車站",
      "order": 94,
      "short_code": "p94"
    },
    {
      "name": "旅行社",
      "order": 96,
      "short_code": "p96"
    },
    {
      "name": "大學",
      "order": 97,
      "short_code": "p97"
    },
    {
      "name": "獸醫護理",
      "order": 98,
      "short_code": "p98"
    },
    {
      "name": "動物園",
      "order": 99,
      "short_code": "p99"
    },
    {
      "name": "其他",
      "order": 100,
      "short_code": "por"
    }
  ]
}